import { render, staticRenderFns } from "./download-zip-button.vue?vue&type=template&id=d5f5efb0&"
import script from "./download-zip-button.vue?vue&type=script&lang=js&"
export * from "./download-zip-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports